export default "__VITE_ASSET__0770683c__"